import { getFeaturedEvents } from 'api/homepage';
import { FeaturedEventItem } from 'api/responseTypes';
import { useQuery } from 'react-query';

const FEATURED_EVENTS_QUERY_KEY = 'featuredEvents';

export const useFeaturedEventsQuery = (): {
  isLoading: boolean;
  items: FeaturedEventItem[];
  isError: boolean;
} => {
  const { isLoading, data, isError } = useQuery(FEATURED_EVENTS_QUERY_KEY, getFeaturedEvents);

  return {
    isLoading,
    items: data?.items ?? [],
    isError: isError ?? false,
  };
};
